import React, { Fragment, useEffect, useMemo, useState } from "react";
import classnames from "classnames";
import {
  // Breadcrumb,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  InputGroup,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import TableContainer from "../TaxAndDeduct/Tax/TableContainerAdmin";
import { GetCookieToken } from "../Cookie/GetCookie";
import dayjs from "dayjs";
import axios from "axios";
import TableContainerReduce from "../TaxAndDeduct/Deduct/TableContainerReduceAdmin";
import LoadingPage from "../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import { Breadcrumbs } from "@mui/material";
import Breadcrumb from "../../components/Common/Breadcrumb";

const API_URL = process.env.REACT_APP_API_CORS;

function TaxAndDeduct() {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  document.title = "เอกสารภาษี | Flexible-Time";

  const token = GetCookieToken("userToken");

  const [fileDataTex, setFileDataTex] = useState([]);
  const [fileDataDeduct, setFileDataDeduct] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [role, setRole] = useState(null);

  const fetchFileDataTex = () => {
    const url = `${API_URL}/api/taxSlip/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 20,
      "order[0]": "year",
      "order[1]": "DESC",
      // search: pushkeyword,
      // "filter[user_id][0]": 1205,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setFileDataTex(response.data.result);
      })
      .catch(error => console.error("Error:", error));
  };

  const fetchFileDataDeduct = () => {
    const url = `${API_URL}/api/reduceTaxSlip/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 20,
      "order[0]": "year",
      "order[1]": "DESC",
      // search: pushkeyword,
      // "filter[user_id][0]": 1205,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setFileDataDeduct(response.data.result);
      })
      .catch(error => console.error("Error:", error));
  };

  const handleButtonClick = value => {
    setLoading(true);
    setTimeout(() => {
      fetchFileDataTex();
      fetchFileDataDeduct();
      setLoading(false);
    }, 1500);
  };

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      fetchFileDataTex();
      fetchFileDataDeduct();
      setLoading(false);
    }, 1500);
  }, []);

  const columnsTex = useMemo(
    () => [
      {
        Header: "ลำดับ",
        accessor: "number",
      },
      {
        Header: "ใบกำกับภาษีหัก ณ ปีที่จ่าย",
        accessor: "yearfilename",
      },
      {
        Header: "ชื่อไฟล์",
        accessor: "filename",
      },
      {
        Header: "วันที่สร้าง",
        accessor: "create",
      },
      // {
      //   Header: "",
      //   accessor: "option",
      // },
    ],
    []
  );

  const columnsDeduct = useMemo(
    () => [
      {
        Header: "ลำดับ",
        accessor: "number",
      },
      {
        Header: "ใบลดหย่อนภาษี",
        accessor: "yearfilename",
      },
      {
        Header: "ชื่อไฟล์",
        accessor: "filename",
      },
      {
        Header: "วันที่สร้าง",
        accessor: "create",
      },
      // {
      //   Header: "",
      //   accessor: "option",
      // },
    ],
    []
  );

  const dataMockTex = [
    {
      number: null,
      yearfilename: null,
      filename: null,
      option: null,
      create: null,
    },
  ];

  const dataTex = fileDataTex
    ?.map((i, index) => ({
      number: index + 1,
      yearfilename: `ใบกำกับภาษีหัก ณ ที่จ่าย ปี ${i.year}`,
      filename: i.name,
      create: dayjs.utc(i.created_date).format("DD/MM/YYYY"),
    }))
    .reverse();

  const dataDeduct = fileDataDeduct
    ?.map((i, index) => ({
      number: index + 1,
      yearfilename: `ใบลดหย่อนภาษี ${i.year}`,
      filename: i.name,
      // option: "",
      // // <EditDeduct year={i.year} onButtonClick={handleButtonClick} />
      create: dayjs.utc(i.created_date).format("DD/MM/YYYY"),
    }))
    .reverse();

  const dataMockDeduct = [
    {
      number: null,
      yearfilename: null,
      filename: null,
      option: null,
      create: null,
    },
  ];

  const refreshDisplay = value => {
    if (value === "รีเฟรชหน้าจอ" || value === "รีเฟรชหน้าจอใบลดหย่อน") {
      setLoading(true);
      setTimeout(() => {
        fetchFileDataTex();
        fetchFileDataDeduct();
        setLoading(false);
      }, 1500);
    }
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Fragment>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="page-content">
          <Container fluid>
            <Breadcrumb
              title="หน้าหลัก"
              breadcrumbItem={`เอกสารภาษี/${activeTab == 1 ? "ระบบใบภาษี" : activeTab == 2 && "ระบบใบลดหย่อนภาษี"}`}
              breadcrumbText="เอกสารภาษี"
              home={true}
            />
            <Card>
              <CardBody className="d-flex justify-content-center">
                <div style={{ width: windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) ? "100%" : "70%" }}>
                  <FadeIn>
                    <Nav tabs>
                      <Nav pills className="navtab-bg w-100" fill>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "1",
                            })}
                            onClick={() => {
                              toggle("1");
                            }}
                          >
                            <h5>
                              ระบบใบภาษี
                            </h5>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "2",
                            })}
                            onClick={() => {
                              toggle("2");
                            }}
                          >
                            <h5>
                              ระบบใบลดหย่อนภาษี
                            </h5>
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        <br />
                        {dataTex !== null &&
                        dataTex !== undefined &&
                        dataTex.length !== 0 ? (
                          <TableContainer
                            refresh={refreshDisplay}
                            columns={columnsTex}
                            data={dataTex}
                            isGlobalFilter={true}
                            isAddOptions={false}
                            customPageSize={5}
                            className="custom-header-css"
                          />
                        ) : (
                          <TableContainer
                            refresh={refreshDisplay}
                            columns={columnsTex}
                            data={dataMockTex}
                            isGlobalFilter={true}
                            isAddOptions={false}
                            customPageSize={5}
                            className="custom-header-css"
                          />
                        )}
                      </TabPane>
                      <TabPane tabId="2">
                        <br />
                        {dataDeduct !== null &&
                        dataDeduct !== undefined &&
                        dataDeduct.length !== 0 ? (
                          <TableContainerReduce
                            refresh={refreshDisplay}
                            columns={columnsDeduct}
                            data={dataDeduct}
                            isGlobalFilter={true}
                            isAddOptions={false}
                            customPageSize={20}
                            className="custom-header-css"
                          />
                        ) : (
                          <TableContainerReduce
                            refresh={refreshDisplay}
                            columns={columnsDeduct}
                            data={dataMockDeduct}
                            isGlobalFilter={true}
                            isAddOptions={false}
                            customPageSize={5}
                            className="custom-header-css"
                          />
                        )}
                      </TabPane>
                    </TabContent>
                  </FadeIn>
                </div>
              </CardBody>
            </Card>
          </Container>
        </div>
      )}
    </Fragment>
  );
}

export default TaxAndDeduct;
